import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchUsers,
    deleteUser,
} from '../redux/slices/userSlice';
import { RiDeleteBin6Line } from "react-icons/ri";
import moment from 'moment';

const UsersList = () => {

    const dispatch = useDispatch();

    const {
        users,
        loading,
        usersPagination = { page: 1, limit: 50, totalPages: 1, total: 0 }
    } = useSelector((state) => state.users);

    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const limit = 10;

    // Fetch users
    useEffect(() => {
        dispatch(fetchUsers({ page, limit, search: searchTerm }));
    }, [dispatch, page, searchTerm]);

    const handleDelete = (userId) => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            dispatch(deleteUser(userId));
        }
    };

    // Counts
    const verifiedCount = users.filter(user => user?.isVerified === true).length;
    const notVerifiedCount = users.filter(user => user?.isVerified === false).length;

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setPage(1);
    };

    return (

        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-sm-12">

                    <div className='card h-100 p-0 radius-12' style={{ padding: '20px' }}>

                        <div className='card-header d-flex justify-content-between align-items-center'>
                            <h6 className='text-dark mb-0'>User List</h6>

                            <input
                                type="text"
                                placeholder="Search by name or email"
                                value={searchTerm}
                                onChange={handleSearch}
                                style={{
                                    borderRadius: 8,
                                    padding: '8px',
                                    marginBottom: '16px',
                                    width: '600',
                                    border: '1px solid #efefef'
                                }}
                            />
                        </div>

                        {loading ? (

                            <div style={{ textAlign: "center", padding: "40px" }}>
                                <div className="spinner-border text-primary" role="status"></div>
                                <p style={{ marginTop: "10px" }}>Loading users...</p>
                            </div>

                        ) : (

                            <div className='card-body'>

                                <div className="table-responsive">

                                    <table className='table table-bordred' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead className="table-dark" style={{ background: '#f4f4f4' }}>
                                            <tr>
                                                <th>#</th>
                                                {/* <th>Referral Code</th> */}
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone Number</th>
                                                <th>Current Plan</th>
                                                <th>Role</th>
                                                <th>Created At</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {users.length > 0 ? (
                                                users.map((user, index) => (
                                                    <tr key={user._id}>
                                                        <td>{(page - 1) * limit + index + 1}</td>
                                                        {/* <td>{user.referralCode}</td> */}
                                                        <td>{user.fullName || '-'}</td>
                                                        <td>{user.email || '-'}</td>
                                                        <td>{user.phone || '-'}</td>

                                                        <td>{user.subscription?.planId?.name || '-'}</td>

                                                        <td>{user.role || '-'}</td>

                                                        <td>{moment(user.createdAt).format('DD/MM/YYYY')}</td>



                                                        <td>
                                                            <button
                                                                onClick={() => handleDelete(user._id)}
                                                                style={{ color: 'red' }}
                                                            >
                                                                <RiDeleteBin6Line />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" style={{ textAlign: 'center' }}>
                                                        No users found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                </div>

                                {/* Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">

                                    <div>
                                        Showing Page <strong>{page}</strong> of{" "}
                                        <strong>{usersPagination.totalPages}</strong>
                                    </div>

                                    <div>

                                        <button
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                            className="btn btn-sm btn-outline-secondary me-2"
                                        >
                                            Previous
                                        </button>

                                        <button
                                            disabled={page === usersPagination.totalPages}
                                            onClick={() => setPage(page + 1)}
                                            className="btn btn-sm btn-outline-secondary"
                                        >
                                            Next
                                        </button>

                                    </div>

                                </div>

                            </div>

                        )}
                    </div>

                </div>
            </div>
        </div>

    );
};

export default UsersList;